import React from 'react';

import { IOrbitIconProps } from './OrbitNewChatIcon';

/**
 * Header action glyph `5118:16678`, the panel's History control: two stroked vectors inside a 17 x
 * 17 box, both
 * `#FFFFFF` at 1 with round cap and join - the message square `5118:16679` (12.04 x 12.37 at
 * (2.125, 2.83)) and the tick `5118:16680` (9.21 x 7.09 at (6.8, 1.7)), whose decoded path matches
 * that node's own `fillGeometry` exactly. The layer is named `Save chat` in the file, which is the
 * designer's library name for the glyph and not what it does here (user, 2026-09-15).
 */
const OrbitHistoryIcon: React.FC<IOrbitIconProps> = ({ width = 17, height = 17, className }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 17 17"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    focusable="false"
    aria-hidden="true"
    data-testid="orbit-icon-history"
  >
    <path
      d="M7.7917 2.8333L5.525 2.8333C4.3349 2.8333 3.7398 2.8333 3.2853 3.0649C2.8854 3.2687 2.5603 3.5938 2.3566 3.9936C2.125 4.4482 2.125 5.0432 2.125 6.2333L2.125 9.9167C2.125 10.5754 2.125 10.9048 2.1974 11.175C2.3939 11.9083 2.9667 12.4811 3.7 12.6776C3.9702 12.75 4.2996 12.75 4.9583 12.75L4.9583 14.4043C4.9583 14.7817 4.9583 14.9705 5.0357 15.0674C5.103 15.1517 5.205 15.2007 5.3129 15.2006C5.4369 15.2005 5.5843 15.0826 5.879 14.8468L7.5687 13.495C7.9139 13.2189 8.0864 13.0808 8.2786 12.9827C8.4491 12.8955 8.6306 12.8319 8.8182 12.7934C9.0296 12.75 9.2506 12.75 9.6927 12.75L10.7667 12.75C11.9568 12.75 12.5518 12.75 13.0064 12.5184C13.4062 12.3147 13.7313 11.9896 13.9351 11.5897C14.1667 11.1352 14.1667 10.5401 14.1667 9.35L14.1667 9.2083"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0083 1.7L8.925 8.7904L6.8 6.6654"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default OrbitHistoryIcon;
